export default __webpack_public_path__ + "static/media/react.b76698cf.png";